import styled from 'styled-components';

import { rgba } from 'polished';

interface WeekDayInfoProps {
  isClosed: boolean;
}

interface ScheduleProps {
  delivery: boolean;
  retirada: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  div.table-caption {
    display: flex;
    gap: 0.750rem;
    align-self: center;
  }

  button.arrow {
    background: none;
    border: none;
    outline: none;
    padding: 5px;
    color: ${({ theme }) => theme.colors.main};
    position: absolute;
    top: 20px;

    svg {
      font-size: 35px;
    }

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 0.625rem;
`;

export const WeekDay = styled.div`
  flex: 1;

  > header {
    display: flex;
  }

  &:first-child {
    div.week-day-schedules {
      border-left: 1px solid ${({ theme }) => theme.colors.grey};
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
    }
  }

  &:last-child {
    div.week-day-schedules {
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
    }
  }
`;

export const WeekDayInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  h3 {
    color: ${({ theme }) => theme.colors.softBlack};
  }
`;

export const WeekDayStatus = styled.div<WeekDayInfoProps>`
  display: flex;
  align-self: center;
  justify-content: center;
  width: 160px;
  border-radius: 20px;
  padding: 7px 15px;
  border: 1px solid
    ${({ isClosed, theme }) =>
      isClosed ? theme.colors.red : theme.colors.green};
  margin: 20px 0 30px;

  span {
    font-size: 13px;
    color: ${({ isClosed, theme }) =>
      isClosed ? theme.colors.red : theme.colors.green};
  }
`;

export const WeekDaySchedule = styled.div`
  position: relative;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  border-left: none;
  overflow: hidden;

  div.grid {
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  }
`;

export const Schedule = styled.button<ScheduleProps>`
  padding: 10px;
  background-color: ${({ retirada, delivery, theme }) => {
    if (retirada && delivery) {
      return rgba(theme.colors.green, 0.2);
    } else if (retirada) {
      return 'rgba(255,137,70,0.1)';
    } else {
      return 'rgba(255,33,144,0.1)';
    }
  }};
  border-radius: 5px;
  position: absolute;
  width: calc(100% - 2px);
  left: 1px;
  top: 220px;
  height: 100px;
  border: none;
  display: flex;

  span {
    color: ${({ retirada, delivery, theme }) => {
    if (retirada && delivery) {
      return theme.colors.green;
    } else if (retirada) {
      return 'rgba(255,137,70)';
    } else {
      return 'rgba(255,33,144)';
    }
  }};;
    font-weight: 600;
    font-family: 'Sora', sans-serif;
  }

  &:hover {
    transition: background-color 0.25s;
    background-color: ${({ retirada, delivery, theme }) => {
    if (retirada && delivery) {
      return rgba(theme.colors.green, 0.3);
    } else if (retirada) {
      return 'rgba(255,137,70,0.3)';
    } else {
      return 'rgba(255,33,144,0.3)';
    }
  }};
  }
`;
